import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionItemPanelListComponent } from './action-item-panel-list/action-item-panel-list.component';
import { ActionItemSearchComponent } from './action-item-search/action-item-search.component';
import { SharedModule } from '../shared/shared.module';
import { BptSearchModule } from 'bpt-ui-library/bpt-search';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActionItemLibraryComponent } from './action-item-library/action-item-library.component';
import { TabViewModule } from 'primeng/tabview';
import { FieldsetModule } from 'primeng/fieldset';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { DialogModule } from 'primeng/dialog';
import { RouterModule } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CalendarModule } from 'primeng/calendar';
import { BptProgressSpinnerModule } from 'bpt-ui-library/bpt-progress-spinner';
import { BptDateTimeModule } from 'bpt-ui-library/bpt-datetime';
import { BptTextInputModule } from 'bpt-ui-library/bpt-text-input';
import { BptNumericInputModule } from 'bpt-ui-library/bpt-numeric-input';
import { BptTagsModule } from 'bpt-ui-library/bpt-tags';
import { BptDropdownModule } from 'bpt-ui-library/bpt-dropdown';
import { ActionItemRoutingModule } from './action-item-routing.module';
import { EmptyResultsComponent } from '../shared-components/empty-results/empty-results.component';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';



@NgModule({
  declarations: [
    ActionItemPanelListComponent,
    ActionItemSearchComponent,
    ActionItemLibraryComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BptSearchModule,
    TooltipModule,
    FormsModule,
    TabViewModule,
    FieldsetModule,
    PanelModule,
    CheckboxModule,
    ToastModule,
    MessageModule,
    MessagesModule,
    DialogModule,
    RouterModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    CalendarModule,
    BptProgressSpinnerModule,
    BptDateTimeModule,
    BptTextInputModule,
    BptNumericInputModule,
    BptTagsModule,
    BptDropdownModule,
    ActionItemRoutingModule,
    EmptyResultsComponent,
    SpinnerComponent
  ],
  exports: [
    ActionItemPanelListComponent,
    ActionItemSearchComponent,
    ActionItemLibraryComponent
  ]
})
export class ActionItemCatalogueModule { }
